import { CONTENT_TYPE } from "../../../constants";
import { removeDrafts } from "../../../utils/removeDrafts";

const getTitle = item => {
	switch (item.sys.contentType.sys.id) {
		case "atomLink":
			return item.fields?.linkText;
		default:
			return item.fields?.title;
	}
};

const getDescription = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageWebinar":
			return item.fields?.lead;
		case "pageIntegration":
			return item.fields?.subtitle;
		case "atomLink":
			return item.fields?.description;
		default:
			return item.fields?.metaDescription;
	}
};

const getImage = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageIntegration":
			return item.fields?.logo?.fields?.file;
		default:
			return item.fields?.thumbnail?.fields?.file;
	}
};

const getType = item => {
	switch (item.sys.contentType.sys.id) {
		case "pageWebinar":
			return item.fields?.eventType || "";
		case "pageIntegration":
			return item.fields?.integrationTag || "";
		case "atomLink":
			return item.fields?.linkTag || "";
		default:
			return "";
	}
};

const getExternalUrl = item => {
	switch (item.sys.contentType.sys.id) {
		case "atomLink":
			return item.fields?.linkUrl;
		default:
			return item.fields?.externalUrl;
	}
};

export const mapItems = items => {
	return items.filter(removeDrafts).map(item => {
		return {
			sys_id: item.sys.id,
			sys_type: item?.fields?.isTutorial ? CONTENT_TYPE.TUTORIAL : item.sys.contentType.sys.id,
			title: getTitle(item),
			description: getDescription(item) || "",
			teaser: item.fields?.teaser || "",
			image: getImage(item)?.url,
			listImages: getImage(item),
			slug: item.fields?.slug || "",
			url: item.fields?.linkUrl || "",
			externalUrl: getExternalUrl(item) || "",
			type: getType(item),
			lead: item.fields?.lead || item.fields?.leadIn || "",
			thumbnail: item.fields?.thumbnail?.fields?.file?.url,
			listThumbnails: item.fields?.thumbnail?.fields?.file,
			articleType: item.fields?.articleType || null,
			eventStatus: item.fields?.eventStatus || null,
			eventType: item.fields?.eventType || null,
		};
	});
};

const mapFeaturedBlock = data => {
	const { items } = data;

	return items.map(item => {
		return {
			sys_id: item.sys.id,
			sys_type: item.sys.contentType.sys.id,
			id: item.fields.id,
			name: item.fields.name,
			blockOrder: item.fields.blockOrder || -100,
			items: mapItems(item.fields.contentReference),
		};
	});
};

export default mapFeaturedBlock;
